import { createFileRoute } from "@tanstack/react-router"

// Note: The breadcrumb for this route is handled by the child routes
// (e.g., /jobs/$jobId) to support different breadcrumb text based on
// whether the job is connected to an event or not.
export const Route = createFileRoute("/(app)/_auth/jobs")({})
